
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Typography, Button, TextareaAutosize, Input, Link } from "@mui/material";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import paeprClipIcon from "../../assets/images/paper-clip.svg";
import DocumentIcon from "../../assets/images/document.svg";
import deleteIcon from "../../assets/images/delete-new-icon.svg";
// import { handleSpaces } from "../../helpers/helper-data";
import { handleSpaces } from "../../helpers/helper";
import { browserName, browserVersion } from "react-device-detect";
import AccessService from  "../../Services/Access.service";
import { danger, success } from "../../helpers/message-box";
import copy from "copy-to-clipboard";
import Loader from "../../Loader";


function FeedBackModal(props) {
    const { open, onClose } = props;
    const currentUrl = window.location.href;
    const appVersion = process.env.REACT_APP_APP_VERSION;
    const [subjectName, setSubjectName] = useState("");
    const [review, setReview] = useState("");
    const hiddenFileInput = React.useRef(null);
    const [ipAddress, setIpAddress] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [browserWidth, setBrowserWidth] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [browserHeight, setBrowserHeight] = useState(null);
    const browser = browserName;
    const version = browserVersion;
    const operatingSystem = getOperatingSystem();
    function getOperatingSystem() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/win64|wow64/i.test(userAgent)) {
            return "Windows 64-bit";
        }

        if (/win32/i.test(userAgent)) {
            return "Windows 32-bit";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        if (/iphone|ipad|ipod/i.test(userAgent)) {
            return "iOS";
        }

        if (/mac/i.test(userAgent)) {
            return "Mac OS";
        }

        if (/linux/i.test(userAgent)) {
            return "Linux";
        }

        return null;
    };
    useEffect(() => {
        if (open) {
            const fetchLocation = () => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            setLatitude(position.coords.latitude);
                            setLongitude(position.coords.longitude);
                        },
                        (error) => {
                        }
                    );
                } else {
                    console.error('Geolocation is not supported by this browser.');
                }
            };
            fetchLocation();
        }
    }, [open]);
    useEffect(() => {
        if (open) {
            const fetchIpAddress = async () => {
                try {
                    const response = await fetch('https://api.ipify.org/?format=json');
                    const data = await response.json();
                    setIpAddress(data.ip);
                } catch (error) {
                    console.error(error);
                }
            };
            fetchIpAddress();
        }
    }, [open]);
    useEffect(() => {
        const handleResize = () => {
              setBrowserWidth(window.innerWidth);
              setBrowserHeight(window.innerHeight);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [open]);
    // console.log()
    const [isScreenshotTrue, setIsScreenshotTrue] = useState([]);
    const takefile = () => {
        hiddenFileInput.current.value = null;
        hiddenFileInput.current.click();
    };
    let pageTitle = document.title?.split("|")[0];
    const handleChange = (event) => {
        const fileUploaded = event.target.files[0];
        if (fileUploaded && fileUploaded.type.startsWith('image/')) {
            if (fileUploaded.size <= 1000000) {
                setIsScreenshotTrue([...isScreenshotTrue, fileUploaded]);
            } else {
                danger("Maximum upload size exceeded. Try to upload a file upto 1MB.");
            }
        } else {
            danger("Please upload only JPG, JPEG, PNG formats!");
        }
    };
    // html2json

    const TextElem = (e) => ({
        type: 'TextElem',
        textContent: e.textContent
        });
        const fromNode = (e) => {
        switch (e?.nodeType) {
        case 1: return Elem(e);
        case 3: return TextElem(e);
        default: throw Error(`unsupported nodeType: ${e.nodeType}`);
        }
        };
        const Elem = (e) => ({
        type: 'Elem',
        tagName: e.tagName,
        // attributes: Array.from(e.attributes, ({ name, value }) => [name, value]),
        children: Array.from(e.childNodes, fromNode)
        });
        const html2json = (e) => JSON.stringify(Elem(e), null, '');
        const getIds = (url) => {
        let id = "";
        if (url.includes('/admin/dashboard')) {
        id = document.getElementById('dashboard');
        } else if (url.includes('/admin/jobs')) {
        id = document.getElementById('joblisting');
        } else if (url.includes('/admin/job-details/')) {
        id = document.getElementById('job-details');
        } else if (url.includes('/admin/job-board-performance')) {
        id = document.getElementById('job-board-performance');
        } else if (url.includes('/admin/job-boards-accesses')) {
          id = document.getElementById('configure-job-board');
        } else if (url.includes('/admin/account-setting')) {
        id = document.getElementById('account-setting');
        }
        return id;
        };
        const getMenuName = (url) => {
               let id;
                 if (url.includes('/admin/dashboard')) {
                   id = "Dashboard";
                 } else if (url.includes('/admin/jobs')) {
                   id = "Job Listing";
                 } else if (url.includes('/admin/job-details/')) {
                   id = "Job Logs";
                 } else if (url.includes('/admin/job-board-performance')) {
                   id = "Reports";
                 } else if (url.includes('/admin/job-boards-accesses')) {
                   id = "Job Boards";
                 } else if (url.includes('/admin/account-setting')) {
                   id = "Account Settings";
                 }
                 return id;
             };

    const handleSubmit = () => {
        setIsLoading(true);
        AccessService.getisFeedBackExist().then((res) => {
            if (res?.data?.responsePayload) {
                const formData = new FormData();
                isScreenshotTrue.forEach((image, index) => {
                    formData.append("attachments", image);
                });
                formData.append('request-body', new Blob([JSON.stringify({
                    browserName: browser,
                    browserVersion: version,
                    appVersion: appVersion,
                    resolution: `${browserWidth}x${browserHeight}`,
                    platform: operatingSystem,
                    application: "hireHQ Beanbag",
                    menuUrl: getMenuName(window.location.pathname),
                    subject: subjectName,
                    feedback: review,
                    ipAddress: ipAddress,
                    userId: localStorage.getItem("consumer_id"),
                    enterpriseName: localStorage.getItem("enterprise_name"),
                    latitude: latitude,
                    longitude: longitude,
                    formData: html2json(getIds(window.location.pathname))
                })], {
                    type: "application/json"
                }));
                AccessService.sendFeedBack(formData).then((response) => {
                    if (response) {
                        success("Thanks for the feedback.");
                        setSubjectName("");
                        setReview("");
                        setIsScreenshotTrue([]);
                        setIsLoading(false);
                        onClose();
                    }
                }).catch((error)=>{
                    setIsLoading(false);
                });
            } else {
                const payload = {
                    Feedback: review,
                    Application: "hireHQ Beanbag",
                    AppVersion: appVersion,
                    Platform: operatingSystem,
                    MenuUrl: getMenuName(window.location.pathname),
                    Subject: subjectName,
                    UserId: localStorage.getItem("consumer_id"),
                    FirstName: localStorage.getItem("user_name")?.split(" ")[0],
                    LastName: localStorage.getItem("user_name").split(" ")[1],
                    Email: localStorage.getItem("email"),
                    Enterprise_Name: localStorage.getItem("enterprise_name"),
                    Latitude: latitude,
                    Longitude: longitude,
                    IpAddress: ipAddress,
                    Resolution: `${browserWidth}x${browserHeight}`,
                    BrowserName: browser,
                    BrowserVersion: version,
                    formData: html2json(getIds(window.location.pathname))
                };
                const payloadString = Object.entries(payload)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join(", ");
                copy(JSON.stringify(payloadString));
                success("Details are copied to the clipboard.");
                setSubjectName("");
                setReview("");
                setIsScreenshotTrue([]);
                setIsLoading(false);
                onClose();
            }
        });
    };
    const handleDeleteImage = (id) => {
        if (isScreenshotTrue.length > 1) {
            setIsScreenshotTrue(
                isScreenshotTrue.filter((location, _index) => _index !== id)
            );
        } else {
            setIsScreenshotTrue([]);
        }
    };
    const handleReset = () => {
        setReview("");
        setIsScreenshotTrue([]);
    };
    const handleModalClose = () => {
        setSubjectName("");
        setReview("");
        setIsScreenshotTrue([]);
        onClose();
    };
    if (isLoading) {
        return <Loader />;
    }
    return (
        <Modal
            open={open}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="feedback"
        >
            <Box className="modal-content align-left inputcontrasts feedback-width">
                <Grid container id="modal-title">
                    <Grid item xs={11}>
                        <Typography
                            className="f-16 font-weight-600 heading-text-color modalTitle black-heading-color p-l-5"
                            align="left"
                        >
                            Feedback
                        </Typography>
                    </Grid>
                    <Grid item xs={1} style={{ marginTop: "-10px" }}>
                        <Typography align="right" className="sub-text-color" onClick={handleModalClose}>
                            <CloseIcon className="cursor-hover" style={{ fontSize: "20px" }}/>
                        </Typography>
                    </Grid>
                </Grid>
                <Grid id="modal-description">
                    <Grid item xs={12}>
                            <Box className=''>
                                <Typography className='f-14'>
                                    Subject<span className="text-black">*</span>{" "}
                                </Typography>
                                <Typography className="feedback-subject mb-10">
                                    <Input
                                        disableUnderline
                                        type="text"
                                        id="overview"
                                        name="overview"
                                        value={subjectName}
                                        onKeyPress={handleSpaces}
                                        onChange={(event) => {
                                            if (event.target.value.length === 1) {
                                                setSubjectName(event.target.value.toUpperCase());
                                                return;
                                            }
                                            setSubjectName(event.target.value);
                                        }}
                                        className="form-control input-group inputcontrasts"
                                        margin="normal"
                                        placeholder="Enter subject"
                                        inputProps={{ maxLength: 128 }}
                                    />
                                </Typography>
                            </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className="font-weight-400 f-14 gray8">
                            Tell us about your experience<span className="text-black">*</span>
                        </Typography>
                        <Typography className="input-focus-none feedback-input">
                            <TextareaAutosize
                                minRows={2}
                                maxRows={4}
                                aria-label="maximum height"
                                className="form-control input-group inputcontrasts"
                                maxLength={256}
                                inputProps={{ maxLength: 256 }}
                                onChange={(e) => {
                                    if (e.target.value.length === 1) {
                                        setReview(e.target.value.toUpperCase());
                                        return;
                                    }
                                    setReview(e.target.value);
                                }}
                                onKeyPress={handleSpaces}
                                name="review"
                                id="review"
                                value={review}
                                placeholder="Enter feedback"
                                style={{ height: "150px" }}
                            />
                            <Typography
                                align="right"
                                className="sub-text-color sub-text-font"
                            >
                                {review?.length ? review?.length : 0}/256
                            </Typography>
                        </Typography>
                        <Typography>
                            {isScreenshotTrue?.length > 0 && <Typography className="d-flex align-center mb-10" style={{ flexDirection: "column" }}>
                                <>
                                    {isScreenshotTrue?.map((image, key) => {
                                        return <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            xs={12}
                                            key={key}
                                            className="d-flex mt-5  justify-between file-cards pt-15 pb-15 pr-10 pl-10  m-l-5"
                                            style={{ width: "100%" }}
                                        >
                                            <Grid
                                                item
                                                lg={10}
                                                md={10}
                                                xs={10}
                                                className="d-flex align-center"
                                            >
                                                {" "}
                                                <img
                                                    src={DocumentIcon}
                                                    alt="img"
                                                    className="m-r-10"
                                                    width="18px"
                                                    height="18px"
                                                />
                                                {" "}
                                                <p className="gray7 f-14 textEllipse text-capitalize">
                                                    {image?.name}
                                                </p>{" "}
                                            </Grid>
                                            <Grid
                                                item
                                                lg={2}
                                                md={2}
                                                xs={2}
                                                className="font-13 align-item-right d-flex"
                                            >
                                                <span
                                                    tabIndex={0}
                                                    onKeyPress={(e) => handleDeleteImage(key)}
                                                    className="align-center d-flex sub-text-font cursor-hover gray7"
                                                    onClick={(e) => handleDeleteImage(key)}
                                                >
                                                    <img
                                                        className="sub-text-font"
                                                        src={deleteIcon}
                                                        alt="delete icon"
                                                    />
                                                </span>
                                            </Grid>
                                        </Grid>;
                                    })}
                                </>
                            </Typography>}
                            {isScreenshotTrue?.length <= 1 &&
                                <Typography className="d-flex align-center">
                                    <img src={paeprClipIcon} />
                                    <Typography className="cursor-hover f-14 font-weight-400 gray8 m-l-5" onClick={takefile}>Add Screenshot</Typography>
                                    <input type="file" accept="image/jpeg, image/png, image/jpg, image/gif" style={{ display: 'none' }} ref={hiddenFileInput} onChange={handleChange} />
                                </Typography>}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid id="modal-footer" className="all_modal-footer d-flex justify-end ">
                    <Typography className="d-flex align-center">
                        {/* <Typography className="link-color f-14 font-weight-400 mr-20" onClick={handleReset}>Reset</Typography> */}
                        <Button
                            className="btn primary-button"
                            disabled={(review?.length>0 && subjectName?.length>0) == ""? true : false}
                            onClick={handleSubmit}
                            tabIndex={0}
                            disableRipple="true"
                        >
                            Submit
                        </Button>
                    </Typography>
                </Grid>
            </Box>
        </Modal>
    );
}

export default FeedBackModal;
